module.exports = __webpack_public_path__ + "img/02.a591c454.jpg";